import { RoomParamsComponent } from './room-params.component';

export const RoomParams = RoomParamsComponent;